// #2712 CLIENTERROR: first, so its listeners see an error App's imports throw.
import "./client-error-boot";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { listenForInstallPrompt } from "./lib/install-prompt";
import "./app.css";

// #4974: the app's one beforeinstallprompt listener, before the first render,
// because the browser can fire it before the signed-in shell mounts.
listenForInstallPrompt();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
